import { connect } from 'react-redux';
import ClientsIndex from '../../components/Clients/Index';
import {
  getClientsTable,
  invitation_client,
  getIndustryOptions,
  send_invitation,
  getTierOptions,
  getAccountManage,
  get_client_options,
  rollbackStatus,
  search_clients,
  getClientName,
  rollbackProfileStatus,
  createClientProfile,
  getTeamMember,
  getAllClientsTable,
  getBusinessUnitOptions,
  inviteBusinessMember,
  configInsightsStandard,
  getConfigInsightsStandard
} from "../../actions/Clients";

import {
  getStates,
  getTimezone
} from "../../actions/Profile";

import {
  getDepartment
} from "../../actions/CreateAccount";

import {
  getRoles
} from "../../actions/employees"

const mapStateToProps = (state) => {
  const {
    tableData,
    tableAllData,
    ifInvitationClientSuccess,
    invitation_client_msg,
    industryOptions,
    ifSendInvitationSuccess,
    send_invitation_error_msg,
    tier_options,
    account_manager,
    client_options,
    client_names,
    ifCreateClientProfileSuccess,
    createClientProfileMessage,
    teamMember_options,
    businessUnitOptions,
    clientId,
    ifCreateClientProfileSuccessBasic
  } = state.clients;

  const {allstates, timezone, ifUpdateSuccess} = state.myProfile;
  const {roles} = state.employees;
  const {department} = state.create_account;
  const {loginUserDetail, token, roleId, roleName} = state.app;
  return {
    clientId,
    tableData,
    tableAllData,
    ifInvitationClientSuccess,
    invitation_client_msg,
    industryOptions,
    ifSendInvitationSuccess,
    send_invitation_error_msg,
    tier_options,
    account_manager,
    client_options,
    allstates,
    timezone,
    department,
    roles,
    ifUpdateSuccess,
    loginUserDetail,
    client_names,
    token,
    ifCreateClientProfileSuccess,
    createClientProfileMessage,
    roleId,
    roleName,
    teamMember_options,
    businessUnitOptions,
    ifCreateClientProfileSuccessBasic
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getClientsTable: (obj) => {
      dispatch(getClientsTable(obj));
    },
    getAllClientsTable: (obj) => {
      dispatch(getAllClientsTable(obj))
    },
    invitation_client: (obj) => {
      dispatch(invitation_client(obj))
    },
    getIndustryOptions: () => {
      dispatch(getIndustryOptions());
    },
    send_invitation: (obj) => {
      dispatch(send_invitation(obj))
    },
    inviteBusinessMember: (obj) => {
      dispatch(inviteBusinessMember(obj))
    },
    getTierOptions: () => {
      dispatch(getTierOptions())
    },
    getAccountManage: () => {
      dispatch(getAccountManage())
    },
    get_client_options: () => {
      dispatch(get_client_options())
    },
    rollbackStatus: () => {
      dispatch(rollbackStatus());
    },
    rollbackProfileStatus: (value) => {
      dispatch(rollbackProfileStatus(value));
    },
    search_clients: (obj) => {
      dispatch(search_clients(obj));
    },
    getStates: () => {
      dispatch(getStates());
    },
    getTimezone: () => {
      dispatch(getTimezone());
    },
    getDepartment: () => {
      dispatch(getDepartment());
    },
    getRoles: () => {
      dispatch(getRoles());
    },
    getClientName: () => {
      dispatch(getClientName());
    },
    createClientProfile: (obj) => {
      dispatch(createClientProfile(obj))
    },
    getTeamMember: (id) => {
      dispatch(getTeamMember(id));
    },
    getBusinessUnitOptions: () => {
      dispatch(getBusinessUnitOptions());
    },
    configInsightsStandard: (id, obj) => {
      dispatch(configInsightsStandard(id, obj))
    },
    getConfigInsightsStandard: (id) => {
      dispatch(getConfigInsightsStandard(id))
    }
  }
}

const Clients = connect (
  mapStateToProps,
  mapDispatchToProps
)(ClientsIndex);

export default Clients;




// WEBPACK FOOTER //
// ./src/containers/Clients/index.js